import React from 'react';
import './NotFound.css';
import Navbar from '../Navbar/Navbar';

const NotFound = () => {
    return (
        <div className='not-found'>
            <Navbar logo='black'/>
            <h1>404</h1>
            <h3>Page Not Found!</h3>
        </div>
    );
};

export default NotFound;